import "styled-components";
import styled, { css, CSSProperties, DefaultTheme } from "styled-components";
import colors from "./colors";

/** 글로벌 테마 선언
 *  Styled-Component 및 theme context에서 사용
 */

const ui = {
  flex_center_center: {
    justifyContent: "center",
    alignContent: "center",
  },
  flex_row_between: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  flex_row_between_center: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  flex_row_between_end: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end",
    justifyContent: "space-between",
  },
  flex_column_center: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  flex_column__center: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  flex_column_between: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  flex_column_between_center: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
  },
  flex_column_end_center: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  flex_column_center_center: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  flex_column_start_center: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  flex_column_center_start: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
  },
  flex_column: {
    display: "flex",
    flexDirection: "column",
  },
  flex_row: {
    display: "flex",
    flexDirection: "row",
  },
  flex_row_center_center: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  flex_row__center: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  flex_row_end_center: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  flex_row_start: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
  },
};

const overflow = {
  ellipsis: {
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  scrollY: () => css`
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 8px;
    }
    &::-webkit-scrollbar-thumb {
      background: ${colors.gray400};
      border-radius: 4px;
    }
  `,
};

const device = {
  uhd: "@media screen and (min-width: 3840px)", // 4K UHD (3840 x 2160) 이상
  wqhd: "@media screen and (min-width: 2560px)", // QHD (2560 x 1440) 이상
  fhd: "@media screen and (min-width: 1920px)", // Full HD (1920 x 1080) 이상
  desktop: "@media screen and (min-width: 1440px)",
  tablet: "@media screen and (min-width: 768px) and (max-width: 1439px)",
  mobile: "@media screen and (max-width: 767px)",
};

export const SmoothAppear = styled.div<{
  $isOpen: boolean;
  $positionY?: number;
}>`
  transform: ${({ $isOpen, $positionY }) =>
    $isOpen
      ? "translateY(0)"
      : $positionY
      ? `translateY(-${$positionY}px)`
      : "translateY(-40px)"};
  transition: transform 0.3s ease, opacity 0.3s ease;
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  pointer-events: ${({ $isOpen }) => ($isOpen ? "auto" : "none")};
`;

type ThemeUiTypes = {
  [key in keyof typeof ui]: any;
};

type ThemeOverflowTypes = {
  [key in keyof typeof overflow]: any;
};

type ThemeDeviceTypes = {
  [key in keyof typeof device]: string;
};

export const theme: DefaultTheme = {
  ui: { ...ui },
  overflow: { ...overflow },
  device: { ...device },
};

export default theme;

declare module "styled-components" {
  export interface DefaultTheme {
    ui: ThemeUiTypes;
    overflow: ThemeOverflowTypes;
    device: ThemeDeviceTypes;
  }
}

export interface ResponsiveProps {
  mobile: string;
  tablet: string;
  desktop: string;
}

export const deviceWidth = {
  desktop: 1440,
  tablet: 1439,
  mobile: 768,
};
